// src/app/core/interceptors/demo-check.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { LocalStorageKeys } from '../../constants/local-storage-keys.enum';

@Injectable()
export class DemoCheckInterceptor implements HttpInterceptor {
  private lastWriteTime = 0;
  private static readonly WRITE_THROTTLE_MS = 30_000;

  constructor(
    private authService: AuthService,
    private localStorage: LocalStorageService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.checkDemoSession();
    return next.handle(req);
  }

  private checkDemoSession() {
    if (this.authService.isDemoMode()) {
      const lastActivity = this.localStorage.get<string>(LocalStorageKeys.DEMO_LAST_ACTIVITY);
      if (lastActivity) {
        const inactivityPeriod = Date.now() - parseInt(lastActivity || '0');

        if (inactivityPeriod > 24 * 60 * 60 * 1000) {
          this.authService.demoLogout().subscribe();
        }
      }

      // Throttle localStorage writes — once per 30s is sufficient for 24h expiry check
      const now = Date.now();
      if (now - this.lastWriteTime >= DemoCheckInterceptor.WRITE_THROTTLE_MS) {
        this.lastWriteTime = now;
        this.localStorage.set(LocalStorageKeys.DEMO_LAST_ACTIVITY, now.toString());
      }
    }
  }
}
